export const APP_ID = "ax_manager_app-tfgjp";